import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const Resume = ({ items }) => {
  const renderItem = (text, value, classNames) => {
    return (
      <div className="flex flex-col gap-3">
        <p className={`text-primary ${classNames?.text}`}>{text}</p>
        <div className="bg-[#E8EDF3] rounded-3xl py-2 px-3.5">
          <span className={`text-[#8D8E92] ${classNames?.value}`}>{value}</span>
        </div>
      </div>
    )
  }
  return (
    <Fragment>
      {items.map((item, index) => (
        <div key={index} className={item.classNames?.container}>
          {renderItem(item.text, item.value, item.classNames)}
        </div>
      ))}
    </Fragment>
  )
}

export default Resume

Resume.propTypes = {
  items: PropTypes.array,
}
